import GameTrialPackage from '../components/Game/GameTrial/GameTrialPackage';

const GameTrialPackagePage = () => {
	return <GameTrialPackage />;
};

export default GameTrialPackagePage;
